import { css } from "@emotion/css";
import type { Properties } from "signlets";

const style = css`
  cursor: pointer;

  &:before {
    content: "No";
  }

  &:checked:before {
    content: "Yes";
  }
`;

export type CheckboxInputProps = {
  value: boolean;
  onChange: (_: boolean) => void;
};

export const CheckboxInput = ({
  value,
  onChange,
}: Properties<CheckboxInputProps>) => {
  const onInput = ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) => {
    const value = currentTarget.checked;
    onChange(value);
  };

  return (
    <input type="checkbox" checked={value} onInput={onInput} class={style} />
  );
};
